import { shade } from "polished";
import styled from "styled-components";
import { TABLET } from "../../styles/breakpoints";

interface ContainerProps {
  borderColor: string;
  backgroundColor: string;
}

export const Container = styled.div<ContainerProps>`
  display: block;
  width: auto;
  min-height: 40px;
  padding: 0 0 0 12px;
  box-shadow: none;
  border: ${({ borderColor }) => `2px solid ${borderColor}`};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0.5rem;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  margin: 0 1.5rem;
  &:hover {
    cursor: pointer;
  }
`;

export const Area = styled.div<{ isShown: boolean }>`
  left: -100px;
  right: 0;
  position: relative;
  top: 0;
  width: 20rem;
  overflow-y: hidden;
  padding: 0 0.6rem;
  background-color: #ffffff;
  border-radius: 10px;
  display: ${({ isShown }) => (isShown ? "flex" : "none")};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  flex-direction: column;
  z-index: 100;

  @media screen and (min-width: ${TABLET}) {
    position: absolute;
    width: 400px;
  }

  @media screen and (max-width: ${TABLET}) {
    position: absolute;
    width: 400px;
  }

  h3 {
    color: ${({ theme }) => shade(0.2, theme.colors.primaryBlue.main)};
  }
  ul {
    display: flex;
    list-style: none;
    font-size: 0.8rem;
    margin: 0;
    padding: 0 0.6rem 0 0;

    color: ${({ theme }) => theme.colors.primaryBlue.text};

    li {
      white-space: break-spaces;
      border-bottom: 1px dotted ${({ theme }) => theme.colors.primaryBlue.text};
      font-size: 1rem;
      color: ${({ theme }) => shade(0.2, theme.colors.primaryBlue.main)};
      border-radius: 10px;
      text-align: left;
      margin-bottom: 0.3125rem;
    }
  }
`;

export const AreaContainer = styled.div`
  display: inline-block;
  position: absolute;
  height: auto;
  width: auto;
  margin-top: 50px;
  z-index: 20;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;

export const PlanInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
